import {DeliveryOptionsType, TurnTime} from 'types/productTypes'

export const getDeliveryOptionByTurnTime = (
  deliveryOptions: DeliveryOptionsType,
  turnTime: TurnTime
) => deliveryOptions?.find(options => options.turnTime === turnTime)
